var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgXTwitter = function SvgXTwitter(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.217 1.27h2.249L9.552 6.885l5.78 7.642h-4.525L7.262 9.892l-4.056 4.635H.956L6.21 8.52.666 1.27h4.64l3.205 4.236 3.706-4.236Zm-.79 11.91h1.247L4.63 2.546H3.292l8.136 10.636Z",
    fill: "#000"
  })));
};
export default SvgXTwitter;